///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import axios from "axios";

import { getAccessToken } from "../helpers/authentication";
import { httpResponseStatus } from "../helpers/types";

var CancelToken = axios.CancelToken;
var isCancel = error => axios.isCancel(error);
var axiosAll = axios.all;
var axiosSpread = axios.spread;

let store;

export const setAxiosStore = storeInstance => {
  store = storeInstance;
};

const getInterceptor = baseURL => {
  const API = axios.create({
    baseURL
  });

  API.interceptors.request.use(
    config => {
      const token = getAccessToken();
      if (token) {
        config.headers["Authorization"] = "Bearer " + token;
      }
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );

  API.interceptors.response.use(
    response => response,
    error => {
      if (error?.response?.status === httpResponseStatus.unauthorized) {
        sessionStorage.clear();
        window.location.reload();
      }

      if (
        error?.response?.status === httpResponseStatus.forbidden &&
        !error?.config?.url?.includes("/user") &&
        !error?.config?.url?.includes("/persons")
      ) {
        if (store) {
          const { setForbiddenError } = require("../slices/appSlice");
          store.dispatch(setForbiddenError());
        }
      }

      return Promise.reject(error);
    }
  );

  return API;
};

const API = getInterceptor(window.REACT_APP_RFQ_WEB_API_BASE_URL);
const loadHistoryAPI = getInterceptor(
  window.REACT_APP_LOAD_HISTORY_WEB_API_BASE_URL
);

export { API, CancelToken, isCancel, axiosAll, axiosSpread, loadHistoryAPI };
